// @ts-nocheck
import React from 'react'

import { TabsBar } from 'components/shared/TabsBar/TabsBar'

export const PaneTabsBar = ({
  activeTab,
  className = undefined,
  tabClassName = undefined,
  tabs,
  onClick,
  isScrollable,
}) => (
  <TabsBar
    alignment="top-left"
    {...{
      activeTab,
      className,
      tabClassName,
      tabs,
      onClick,
      isScrollable,
    }}
  />
)
